/* quote-cart.js — Request-for-Quote cart (localStorage based)
   assets/quote-cart.js  — load once globally (theme.liquid, before </body>):
     <script src="{{ 'quote-cart.js' | asset_url }}" defer></script>
*/
(function () {
  if (window.QuoteCart) return;

  var KEY = 'clineplus_quote_v1';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(items) { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} emit(); }

  var listeners = [];
  function emit() { var items = read(); listeners.forEach(function (fn) { try { fn(items); } catch (e) {} }); }
  function onChange(fn) { listeners.push(fn); try { fn(read()); } catch (e) {} }

  function add(item) {
    var items = read(), existing = null;
    for (var i = 0; i < items.length; i++) { if (items[i].key === item.key) { existing = items[i]; break; } }
    if (existing) { existing.qty = (existing.qty || 0) + (item.qty || 1); }
    else { items.push(item); }
    write(items);
  }
  function setQty(key, qty) { var items = read(); items.forEach(function (i) { if (i.key === key) i.qty = Math.max(1, qty || 1); }); write(items); }
  function setOffer(key, offer) { var items = read(); items.forEach(function (i) { if (i.key === key) i.offer = offer; }); write(items); }
  function remove(key) { write(read().filter(function (i) { return i.key !== key; })); }
  function clear() { write([]); }
  function distinct() { return read().length; }

  window.QuoteCart = { read: read, add: add, setQty: setQty, setOffer: setOffer, remove: remove, clear: clear, distinct: distinct, onChange: onChange };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---- Nav badge ---- */
  function updateBadges() {
    var n = distinct();
    document.querySelectorAll('[data-quote-count]').forEach(function (el) { el.textContent = n; el.style.display = n > 0 ? '' : 'none'; });
  }
  onChange(updateBadges);

  /* ---- Locate the product form even when the button sits outside it ---- */
  function productForm(btn) {
    var f = btn.closest('form[action*="/cart/add"]');
    if (f) return f;
    var host = btn.closest('[data-form-id]') || document.getElementById('main-product');
    if (host) {
      var fid = host.getAttribute && host.getAttribute('data-form-id');
      if (fid) { var byId = document.getElementById(fid); if (byId) return byId; }
      var inHost = host.querySelector('form[action*="/cart/add"]');
      if (inHost) return inHost;
    }
    return document.querySelector('form[action*="/cart/add"]');
  }

  /* ---- "Add to quote" buttons ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quote-add]');
    if (!btn) return;
    e.preventDefault();

    var pform = productForm(btn);
    var variant = '';
    var qty = parseInt(btn.getAttribute('data-qty') || '1', 10);
    if (pform) {
      var idEl = pform.querySelector('[name="id"]');
      if (idEl && idEl.value) variant = idEl.value;                 // selected variant
      var qEl = pform.querySelector('[name="quantity"]');
      if (qEl && qEl.value) qty = parseInt(qEl.value, 10) || qty;   // quantity box on the page
    }
    if (!qty || qty < 1) qty = 1;

    add({
      key: String(variant || btn.getAttribute('data-product-id')),
      title: btn.getAttribute('data-title'),
      image: btn.getAttribute('data-image'),
      url: btn.getAttribute('data-url'),
      qty: qty,
      offer: ''
    });

    var orig = btn.innerHTML;
    btn.innerHTML = btn.getAttribute('data-added-label') || 'Added to quote';
    btn.disabled = true;
    setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1300);
  });

  /* ---- Cart page rendering (idempotent: only rebuild when rows change) ---- */
  function sameKeys(a, b) { if (a.length !== b.length) return false; for (var i = 0; i < a.length; i++) { if (a[i] !== b[i]) return false; } return true; }

  function renderCart() {
    var root = document.querySelector('[data-quote-cart]');
    if (!root) return;
    var items = read();
    var list = root.querySelector('[data-quote-items]');
    var empty = root.querySelector('[data-quote-empty]');
    var body = root.querySelector('[data-quote-body]');

    if (!items.length) {
      if (list) list.innerHTML = '';
      if (empty) empty.style.display = '';
      if (body) body.style.display = 'none';
      return;
    }
    if (empty) empty.style.display = 'none';
    if (body) body.style.display = '';
    if (!list) return;

    // Skip rebuild when the set of rows is unchanged — preserves focus while typing.
    var existing = Array.prototype.map.call(list.querySelectorAll('.qc-row'), function (r) { return r.getAttribute('data-key'); });
    var keys = items.map(function (i) { return String(i.key); });
    if (sameKeys(existing, keys)) return;

    list.innerHTML = items.map(function (i) {
      return '' +
        '<tr class="qc-row" data-key="' + esc(i.key) + '">' +
          '<td class="qc-prod"><a href="' + esc(i.url) + '" class="qc-link">' +
            (i.image ? '<img src="' + esc(i.image) + '" alt="" class="qc-img" loading="lazy">' : '<span class="qc-img qc-img--ph"></span>') +
            '<span class="qc-name">' + esc(i.title) + '</span></a></td>' +
          '<td class="qc-qty"><input type="number" min="1" step="1" value="' + (i.qty) + '" data-qc-qty aria-label="Quantity"></td>' +
          '<td class="qc-offer"><input type="text" inputmode="decimal" placeholder="$ per unit" value="' + esc(i.offer || '') + '" data-qc-offer aria-label="Your offer price per unit"></td>' +
          '<td class="qc-rm"><button type="button" class="qc-remove" data-qc-remove aria-label="Remove item">Remove</button></td>' +
        '</tr>';
    }).join('');
  }

  document.addEventListener('input', function (e) {
    var row = e.target.closest('.qc-row'); if (!row) return;
    var key = row.getAttribute('data-key');
    if (e.target.matches('[data-qc-qty]')) setQty(key, parseInt(e.target.value, 10) || 1);
    if (e.target.matches('[data-qc-offer]')) setOffer(key, e.target.value);
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-qc-remove]'); if (!rm) return;
    var row = rm.closest('.qc-row'); if (!row) return;
    remove(row.getAttribute('data-key'));
  });

  onChange(renderCart);
  document.addEventListener('DOMContentLoaded', renderCart);

  /* ---- Email body on submit ---- */
  function field(form, id) { var el = form.querySelector('#' + id); return el ? (el.value || '').trim() : ''; }
  function fmtOffer(o) { if (!o) return ''; var s = String(o).trim().replace(/^\$+/, '').trim(); return s ? '$' + s : ''; }

  function buildBody(form, items) {
    var line = '--------------------------------------------------';
    var products = items.map(function (i) {
      var s = (i.qty) + 'x ' + i.title;
      var off = fmtOffer(i.offer);
      if (off) s += ' — Customer offers ' + off + ' per unit';
      return s;
    });
    return [
      'Hi Cline Plus,', '',
      'You have requested a new request for quote for the below products:',
      line, products.join('\n'), line, '',
      "Below are the customer's contact information:",
      'Name: ' + field(form, 'qf-name'),
      'Company Name: ' + field(form, 'qf-company'),
      'Address: ' + field(form, 'qf-address'),
      'Email: ' + field(form, 'qf-email'),
      'Phone: ' + field(form, 'qf-phone'),
      '', 'Comment from Customer:',
      (field(form, 'qf-comment') || '(none)')
    ].join('\n');
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.js-quote-form'); if (!form) return;
    var hp = form.querySelector('.qc-hp'); if (hp && hp.value) { e.preventDefault(); return; }
    var items = read();
    if (!items.length) { e.preventDefault(); alert('Your quote list is empty — add a product first.'); return; }
    var bodyEl = form.querySelector('[name="contact[body]"]');
    if (bodyEl) bodyEl.value = buildBody(form, items);
  });

  /* ---- Success: show the banner and clear the cart (marker only renders on success) ---- */
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('[data-quote-posted]')) return;
    var banner = document.querySelector('[data-quote-success]');
    if (banner) { banner.hidden = false; banner.removeAttribute('hidden'); try { banner.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
    clear();
  });
})();
